export default {
	'add-new-product': '',
	'the-product': '',
	product: '',
	confirm: '',
	'are-you-sure-you-want-to-$-this-user': '',
	activate: '',
	deactivate: '',
}